import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';

@Directive({
  selector: '[confirm]'
})
export class ConfirmDirective {

  @Input()
  confirmMessage: string = 'Sei sicuro?';

  @Output()
  confirm = new EventEmitter<any>();

  constructor(private el: ElementRef) {
  }

  @HostListener('click')
  onClick() {
    const ret:boolean  = window.confirm(this.confirmMessage);
    if(ret)
      this.confirm.emit(ret);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/confirm.directive.ts